
const widgets = document.querySelectorAll(".variants-selector__wrapper");
const prices = document.querySelectorAll(".variants-selector__prices");
const purchaseInputs = document.querySelectorAll("input[name='variant-option']");

purchaseInputs.forEach((purchaseInput)=>{
  purchaseInput.addEventListener("change", function(e){   
    const currentValue = purchaseInput.value;
	  const featuredImage = purchaseInput.dataset.image;

        widgets.forEach((widget)=>{
          if(currentValue!=widget.getAttribute("data-purchase")){
           !widget.classList.contains("widget-hide") ? widget.classList.add("widget-hide") : null;
           widget.classList.contains("widget-active") ? widget.classList.remove("widget-active") : null;
          } else{
              widget.classList.contains("widget-hide") ? widget.classList.remove("widget-hide") : null;
            !widget.classList.contains("widget-active") ? widget.classList.add("widget-active") : null;
            const activeRadio = document.querySelector(".widget-active .selling-widget__plan input[type='radio']:checked");         
          }
        })
        prices.forEach((price)=>{
	
          if(currentValue!=price.getAttribute("data-purchase")){
           price.classList.contains("current-price") ? price.classList.remove("current-price") : null;
          } else{
            !price.classList.contains("current-price") ? price.classList.add("current-price") : null;

          }
        })
	if(featuredImage){
		const sliderThumb = purchaseInput.closest("section").querySelector(`.gem-slider-item[media-poster='${featuredImage}']`);
		sliderThumb.click();
	}
  })
})

async function addAllToCart(button){
  button.classList.add("loading");
  const formData = [];
  const variantId = document.querySelector(".variants-selector__wrapper.widget-active input.variants-selector_variant-id").value;
  const quantity = 1;
  const upsells = document.querySelectorAll(".variants-selector__wrapper.widget-active .hh-upsell-btn");
    if(upsells && upsells.length > 0){
        upsells.forEach((upsell)=>{
        formData.push({ id: upsell.dataset.variantId, quantity: 1 });
        })
    }
  const freeProduct = document.querySelector(".variants-widget .free-product");
    if(freeProduct){
      formData.push({ id: freeProduct.dataset.id, quantity: 1 });
    }
  formData.push(
    { id: variantId, 
      quantity: parseInt(quantity), 
      
    }
  );
 
  await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: formData }),
  })
  .then(response => response.json())
  .then(data => {
  
    window.SLIDECART_UPDATE(function(){
      button.classList.remove("loading");
      window.SLIDECART_OPEN();
    });
    

    
  })
  .catch(error => {
      console.error('Error adding to cart:', error);
  });

}
const buyButtons = document.querySelectorAll(".selling-widget__button");
 buyButtons.forEach((buyButton)=>{
       buyButton.addEventListener("click", function(e){
       addAllToCart(buyButton)
    
  })  
})
window.addEventListener("load", function(e){
  const defaultVariant = document.querySelector(".variants-widget .variants-selector__option[data-default='true']");
  defaultVariant ? defaultVariant.click() : null;
})
